import React from 'react';
import { Box, Typography } from '@mui/material';
import { useArquivosModule } from '../modules/useArquivosModule';
import ArquivosTab from './ArquivosTab';

export default function ArquivosDetailPanel({ documento, permissoes, parametro, isMobile }) {
    const arquivos = useArquivosModule({ documento, permissoes, bloqueado: false, somenteConsulta: true });
    return <Box sx={{ minWidth: 0, width: '100%', p: { xs: 0, sm: 1 } }}>
        <Typography variant="subtitle1">Arquivos: {documento.titulo}</Typography>
        <ArquivosTab modulo={arquivos} documento={documento} permissoes={permissoes}
            parametro={parametro} isMobile={isMobile} cabecalhoPendente={false} somenteConsulta />
    </Box>;
}
